import { graphql, useStaticQuery } from 'gatsby';

export interface PathPrefixQuery {
  site: {
    pathPrefix: string;
  };
}

const usePathPrefix = () => {
  const { site } = useStaticQuery<PathPrefixQuery>(
    graphql`
      query usePathPrefixQuery {
        site {
          pathPrefix
        }
      }
    `,
  );

  return site.pathPrefix;
};

export default usePathPrefix;
